import { render, staticRenderFns } from "./LocalOcorrenciaCollapse.vue?vue&type=template&id=4d38aaaa&scoped=true&"
import script from "./LocalOcorrenciaCollapse.vue?vue&type=script&lang=js&"
export * from "./LocalOcorrenciaCollapse.vue?vue&type=script&lang=js&"
import style0 from "./LocalOcorrenciaCollapse.vue?vue&type=style&index=0&id=4d38aaaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38aaaa",
  null
  
)

export default component.exports